import React from "react"
import { makeStyles } from "tss-react/mui"
import { Box, MenuItem, Typography } from "@mui/material"
import {
    FormikDropdown,
    FormikNoteInput,
    FormikNumberField,
    FormikSwitch,
    FormikTextArea,
    FormikTextField,
} from "../../../../../../../shared/components/forms/Formik"
import { CreateOrEditPriceListFormValues, CurrencyCode, PriceAdjustmentType } from "../../../priceListTypes"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { useFormikContext } from "formik"
import { SelectShop } from "./SelectShop"
import { SelectVatCode } from "./SelectVatCode"
import { StandardForm } from "../../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../../shared/components/forms/StandardMainPanel"
import { StandardSidePanel } from "../../../../../../../shared/components/forms/StandardSidePanel"

const useStyles = makeStyles()(() => ({
    percentageInput: {
        width: "7.5rem",
    },
}))

export function FormGeneralContent() {
    const { values } = useFormikContext<CreateOrEditPriceListFormValues>()
    const { classes } = useStyles()

    return (
        <StandardForm>
            <StandardMainPanel>
                <LocalizedStrict id="create-or-edit-price-list-field-name" attrs={{ label: true }}>
                    <FormikTextField name="name" label="Name" fullWidth />
                </LocalizedStrict>
                <SelectShop />
                <LocalizedStrict id="create-or-edit-price-list-field-internal-note" attrs={{ placeholder: true }}>
                    <FormikNoteInput name="internalNote" placeholder="Internal note:" fullWidth />
                </LocalizedStrict>
            </StandardMainPanel>
            <LocalizedStrict id="create-or-edit-price-list-field-aside-settings" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Settings">
                    <LocalizedStrict id="create-or-edit-price-list-field-active">
                        <FormikSwitch<CreateOrEditPriceListFormValues> name="isActive">Active:</FormikSwitch>
                    </LocalizedStrict>
                    <LocalizedStrict id="create-or-edit-price-list-field-message-to-customers" attrs={{ label: true }}>
                        <FormikTextArea
                            fullWidth
                            label="Message to customer"
                            name="messageToCustomers"
                        />
                    </LocalizedStrict>
                </StandardSidePanel>
            </LocalizedStrict>
            <LocalizedStrict id="create-or-edit-price-list-aside-pricing" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Pricing">
                    <SelectVatCode />
                    <LocalizedStrict id="create-or-edit-price-list-field-price-includes-vat">
                        <FormikSwitch<CreateOrEditPriceListFormValues> name="priceIncludesVat">
                            Price list incl. VAT:
                        </FormikSwitch>
                    </LocalizedStrict>
                    <LocalizedStrict id="create-or-edit-price-list-field-currency-code" attrs={{ label: true }}>
                        <FormikDropdown<CreateOrEditPriceListFormValues>
                            fullWidth
                            name="currencyCode"
                            label="Currency code"
                        >
                            <MenuItem value={CurrencyCode.DKK}>
                                <LocalizedStrict id="create-or-edit-price-list-field-dropdown-dkk">
                                    <span>DKK</span>
                                </LocalizedStrict>
                            </MenuItem>
                        </FormikDropdown>
                    </LocalizedStrict>

                    <LocalizedStrict id="create-or-edit-price-list-field-price-adjustment" attrs={{ label: true }}>
                        <FormikDropdown<CreateOrEditPriceListFormValues>
                            fullWidth
                            name="priceAdjustmentType"
                            label="Price adjustment"
                        >
                            <MenuItem value={PriceAdjustmentType.NONE}>
                                <LocalizedStrict id="create-or-edit-price-list-field-dropdown-none">
                                    <span>None</span>
                                </LocalizedStrict>
                            </MenuItem>
                            <MenuItem value={PriceAdjustmentType.REDUCTION}>
                                <LocalizedStrict id="create-or-edit-price-list-field-dropdown-discount">
                                    <span>Discount</span>
                                </LocalizedStrict>
                            </MenuItem>
                            <MenuItem value={PriceAdjustmentType.INCREASE}>
                                <LocalizedStrict id="create-or-edit-price-list-field-dropdown-increase">
                                    <span>Increase</span>
                                </LocalizedStrict>
                            </MenuItem>
                        </FormikDropdown>
                    </LocalizedStrict>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <LocalizedStrict id="create-or-edit-price-list-field-percentage">
                            <Typography>Percentage (%):</Typography>
                        </LocalizedStrict>
                        <FormikNumberField
                            disabled={values.priceAdjustmentType === PriceAdjustmentType.NONE}
                            range="non-negative-decimal"
                            decimalScale={2}
                            name="percentage"
                            min={0}
                            max={100}
                            className={classes.percentageInput}
                        />
                    </Box>
                </StandardSidePanel>
            </LocalizedStrict>
        </StandardForm>
    )
}
